import { createSlice } from "@reduxjs/toolkit";


const initialSearchState = {
    results: [],
    patientsPageResults: null,
    patientsPageResultsLoader: false,
    filters: [],
    relatedPatientsResults: [],
    patientListFiltersParams: null,
    isAPracticeUsedAsFilter: null,
    // patientWorkQueueSearch: []
}


const searchSlice = createSlice({
    name: 'search',
    initialState: initialSearchState,
    reducers: {
        setSearchResults(state, data) {
            state.results = data.payload
        },
        setPatientsPageResults(state, data) {
            state.patientsPageResults = data.payload
        },
        setPatientsPageResultsLoader(state, data) {
            state.patientsPageResultsLoader = data.payload
        },
        setFilters(state, data) {
            const index = state.filters.findIndex(object => {
                return object.name == data.payload.name
            })

            if (index < 0) {
                state.filters.push(data.payload)
            } else {
                state.filters[index].value = data.payload.value
            }
           
        },
        removeOneFilter(state, key) {
            const index = state.filters.findIndex(object => {
                return object.name == key.payload
            })

            if (index !== -1) {
                state.filters.splice(index, 1)
            }
        },
        removeAllFilters(state) {
            state.filters = []
        },

        setRelatedPatientsResults(state, data) {
            state.relatedPatientsResults = data.payload
        },
        savePatientListFiltersParams(state, data) {
            state.patientListFiltersParams = data.payload
        },
        setIsAPracticeUsedAsFilter(state, data) {
            state.isAPracticeUsedAsFilter = data.payload
        },
        // setPatientWorkQueueSearch(state, data) {
        //     state.patientWorkQueueSearch = data.payload
        // },
    }
})

export const searchActions = searchSlice.actions

export default searchSlice.reducer